import { useTranslation } from 'react-i18next';

export default function Support() {
  const { t } = useTranslation();
  const channels = [
    { icon: 'ri-whatsapp-line', color: 'from-green-500 to-emerald-500', titleKey: 'support.s1_title', descKey: 'support.s1_desc', speedKey: 'support.s1_speed', hoursKey: 'support.s1_hours', contact: '+12057092376' },
    { icon: 'ri-phone-line', color: 'from-blue-500 to-cyan-500', titleKey: 'support.s2_title', descKey: 'support.s2_desc', speedKey: 'support.s2_speed', hoursKey: 'support.s2_hours', contact: '+12057092376' },
    { icon: 'ri-mail-line', color: 'from-purple-500 to-pink-500', titleKey: 'support.s3_title', descKey: 'support.s3_desc', speedKey: 'support.s3_speed', hoursKey: 'support.s3_hours', contact: 'support@4kdream.com' },
    { icon: 'ri-home-line', color: 'from-orange-500 to-[#862ce0]', titleKey: 'support.s4_title', descKey: 'support.s4_desc', speedKey: 'support.s4_speed', hoursKey: 'support.s4_hours', contact: t('support.s4_contact') },
  ];
  return (
    <section id="support" className="py-6 md:py-8 bg-gradient-to-br from-gray-900 via-green-900/20 to-blue-900/20">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-green-400 via-blue-500 to-purple-500 bg-clip-text text-transparent">{t('support.title')}</h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto mb-8">{t('support.desc')}</p>
          <div className="relative max-w-4xl mx-auto mb-12">
            <img src="https://4kdreamers.com/iptv-support-D1W-sOPd.jpg" alt="Support" className="w-full h-auto rounded-2xl" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-r from-green-600/20 to-blue-600/20 rounded-2xl" />
            <div className="absolute top-4 left-4">
              <span className="bg-green-500 text-white font-bold px-4 py-2 rounded-full text-xs animate-pulse">🟢 Support Actif 24/7</span>
            </div>
          </div>
        </div>
        <div className="mb-16">
          <h3 className="text-3xl font-bold text-center mb-12 text-white">{t('support.channels_title')}</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {channels.map(({ icon, color, titleKey, descKey, speedKey, hoursKey, contact }) => (
              <div key={titleKey} className="bg-gray-800/50 border border-gray-700 hover:border-green-500/50 transition-all duration-300 rounded-lg group">
                <div className="p-6 text-center">
                  <div className={`w-16 h-16 bg-gradient-to-r ${color} rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300`}>
                    <i className={`${icon} text-white text-3xl`} />
                  </div>
                  <h3 className="font-semibold text-white text-lg mb-2">{t(titleKey)}</h3>
                  <p className="text-gray-400 text-sm mb-3">{t(descKey)}</p>
                  <div className="flex flex-col gap-1 mb-3">
                    <span className="inline-block bg-green-500/20 text-green-400 border border-green-500/30 text-xs px-2.5 py-0.5 rounded-full font-semibold">⚡ {t(speedKey)}</span>
                    <span className="inline-block border border-gray-600 text-gray-300 text-xs px-2.5 py-0.5 rounded-full font-semibold">🕒 {t(hoursKey)}</span>
                  </div>
                  <div className="text-white font-mono text-sm p-2 bg-gray-700/50 rounded break-all">{contact}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="text-center">
          <a href="https://wa.me/12057092376" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-gradient-to-r from-green-500 via-blue-500 to-purple-500 hover:opacity-90 text-white px-8 py-4 text-lg font-semibold rounded-md mr-4 cursor-pointer whitespace-nowrap">
            <i className="ri-whatsapp-line" /> {t('support.cta_whatsapp')}
          </a>
          <a href="tel:+12057092376" className="inline-flex items-center gap-2 border border-green-500/50 text-green-400 hover:bg-green-500/20 px-8 py-4 text-lg rounded-md cursor-pointer whitespace-nowrap">+12057092376</a>
          <p className="text-gray-400 text-sm mt-4">{t('support.note')}</p>
        </div>
      </div>
    </section>
  );
}
